import { render, staticRenderFns } from "./detail-transaction-types.vue?vue&type=template&id=9f8dc516&scoped=true"
import script from "./detail-transaction-types.vue?vue&type=script&lang=js"
export * from "./detail-transaction-types.vue?vue&type=script&lang=js"
import style0 from "./detail-transaction-types.vue?vue&type=style&index=0&id=9f8dc516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8dc516",
  null
  
)

export default component.exports